/* MARTI & ROK — theme.js
   Behaviour only. Every interaction here is one Shopify can express: a variant
   change, a line-item quantity, an add-to-cart, a cookie consent. Nothing
   invents a cart interaction the platform does not have (§3).
   No dependencies. Ships into the theme as assets/theme.js. */

(function () {
  "use strict";

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* --- Quantity -----------------------------------------------------------
     One control, clamped at 1. The output is aria-live so the change is
     announced rather than only seen. */
  $$("[data-qty]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var out = $("[data-qty-out]", btn.parentNode);
      if (!out) return;
      var next = Math.max(1, (parseInt(out.textContent, 10) || 1) + parseInt(btn.dataset.qty, 10));
      out.textContent = next;
      /* The theme posts a real form to /cart/add, and an <output> is not
         submitted. Where a hidden quantity field exists the control writes
         through to it, so the number the buyer sees is the number that is
         ordered. Nothing in the prototype carries the attribute, so this is
         inert here and the two copies of the file stay identical. */
      var host = btn.closest("form") || btn.closest("section") || document;
      var field = $("[data-qty-input]", host);
      if (field) field.value = next;
    });
  });

  /* --- Product gallery ---------------------------------------------------
     The thumbnails were markup only until 2026-08-26: <button>s that nothing
     bound, each announcing "View image N of M" while clicking did nothing at
     all. So a shop that sells pictures showed one picture, and
     storefront/tests/test_gallery.py passed the whole time -- it guarded the
     ORDER of images nobody could click.

     The stage image is swapped rather than the gallery re-rendered, so the
     stage keeps its height and the page does not move, which is the same rule
     the size control follows. A thumb with no data-full is a placeholder plate
     and is left inert rather than clearing the stage. */
  $$("[data-thumb]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var media = btn.closest(".product-media");
      var stage = media && $("[data-stage]", media);
      if (!stage || !btn.dataset.full) return;
      /* srcset FIRST, and it must be cleared. A browser ignores `src`
         entirely while a `srcset` is present, so assigning `src` alone would
         leave the stage showing the lead photograph however many thumbs were
         clicked -- the same dead control that was fixed on 2026-08-26, coming
         back as a side effect of making the first paint smaller. The stage
         carries a srcset for its LCP render; after a click it is one chosen
         picture at full width and does not need one. */
      stage.removeAttribute("srcset");
      stage.removeAttribute("sizes");
      stage.src = btn.dataset.full;
      stage.alt = btn.dataset.alt || "";
      if (btn.dataset.ar) stage.style.setProperty("--ar", btn.dataset.ar);
      $$("[data-thumb]", media).forEach(function (b) {
        b.removeAttribute("aria-current");
      });
      btn.setAttribute("aria-current", "true");
    });
  });

  /* --- Size selection -----------------------------------------------------
     The authored moment. Changing size moves the fill in the diagram and the
     figure in the button. Neither moves the page: the stage keeps its height,
     and the price is tabular.

     The sizes nest strictly, so a sheet smaller than the selected one falls
     inside the filled area and switches to a paper stroke. That is a rule, not
     a lookup: index below selected is inside, index above is outside. */
  $$("fieldset.sizes").forEach(function (set) {
    var scope  = set.closest("section") || document;
    var sheets = $$(".sized .sheet[data-i]", scope);
    var priceOut = $("[data-price-out]", scope);
    var order = $$("input[type=radio]", set).map(function (i) { return i.value; });

    set.addEventListener("change", function (e) {
      var input = e.target;
      if (!input || input.type !== "radio") return;
      var sel = order.indexOf(input.value);

      sheets.forEach(function (r) {
        var i = parseInt(r.dataset.i, 10);
        r.classList.toggle("sheet--on", i === sel);
        r.classList.toggle("sheet--in", i < sel);
      });

      if (priceOut && input.dataset.price) priceOut.textContent = input.dataset.price;

      /* THE VARIANT ID IS NO LONGER WRITTEN FROM THIS RADIO. It used to be
         `idField.value = input.value`, which was right exactly while a print
         had one option. With Edition as option 2 the thing in the cart is
         decided by both controls and by neither alone, so it is resolved from
         the map by `resolveVariant` below -- and the size radio now carries
         the size OPTION VALUE rather than a variant id. wall.js is
         unaffected: it reads data-mm-w and data-mm-h, never the value. */

      var add = $("[data-add]", scope);
      if (add && add.dataset.state === "added") {
        delete add.dataset.state;
        add.firstChild.nodeValue = "Add to cart — €";
      }
      resolveVariant(scope);
    });
  });

  /* --- Edition ------------------------------------------------------------
     The second buyable variant of a print: the same artwork on a sheet with a
     printed footer (P1.57). Two things move when it changes, and they are
     separate on purpose.

     THE GALLERY. Both editions' photographs are in the markup and one set is
     hidden. Switching shows that edition's pictures and puts its first one on
     the stage. It is not a filter over one merged gallery: these are
     photographs of two different printed sheets, and showing the annotated
     footer while Standard is checked is showing type that will not be on the
     buyer's print.

     THE VARIANT. Size is option 1 and Edition is option 2, so the thing that
     goes in the cart is decided by BOTH controls and by neither alone. That
     is why the id is resolved from a map rather than carried on a radio: a
     radio can only know its own answer, and the previous version wrote the
     size radio's value straight into the hidden field — correct while a print
     had three variants and quietly wrong the moment it had six. */
  function editionOf(scope) {
    var checked = $("fieldset.editions input:checked", scope);
    return checked ? checked.value : "";
  }

  function resolveVariant(scope) {
    var host = $("[data-variant-map]", scope);
    var idField = $("[data-variant-input]", scope);
    if (!host || !idField) return;              /* prototype: no cart, no map */
    var map;
    try { map = JSON.parse(host.dataset.variantMap || "{}"); } catch (e) { return; }
    var size = $("fieldset.sizes input:checked", scope);
    if (!size) return;
    /* Nested by size, then edition -- never one joined key. A separator
       would have to be a character no option value can contain, and
       Liquid has no escape for the invisible ones, so the two copies of
       this file could only ever have agreed by luck. */
    var bySize = map[size.value] || {};
    var row = bySize[editionOf(scope)];
    /* NO FALLBACK TO A DIFFERENT VARIANT. A combination the shop does not
       carry must leave the form unable to post rather than post a variant the
       buyer did not choose -- which is how a shop sells the standard sheet to
       somebody who picked the annotated one and never finds out. */
    var add = $("[data-add-submit]", scope) || $("button[name=add]", scope);
    if (!row) {
      idField.value = "";
      if (add) { add.disabled = true; add.setAttribute("aria-disabled", "true"); }
      return;
    }
    idField.value = row.id;
    if (add) {
      add.disabled = !row.ok;
      if (row.ok) add.removeAttribute("aria-disabled");
      else add.setAttribute("aria-disabled", "true");
    }
    var priceOut = $("[data-price-out]", scope);
    if (priceOut && row.price) priceOut.textContent = row.price;

    /* THE SIZE LIST IS REPRICED FOR THE CHOSEN EDITION, not left as it was
       rendered. Both editions cost the same today -- same paper, same size,
       same print cost, one answer from posters.retail_for() -- so this
       changes nothing on the live shop. It is here because "the two are
       always equal" is a fact about a price table, not a property of the
       markup, and a control showing one edition's prices while the buyer has
       chosen the other is the kind of quietly-wrong page this theme keeps
       finding. Six lines is cheaper than a rule somebody has to remember. */
    $$("fieldset.sizes input[type=radio]", scope).forEach(function (r) {
      var alt = (map[r.value] || {})[editionOf(scope)];
      if (!alt || !alt.price) return;
      r.dataset.price = alt.price;
      var cell = $(".size__p", r.parentNode);
      if (cell) cell.textContent = alt.price;
    });
  }

  $$("fieldset.editions").forEach(function (set) {
    var scope = set.closest("section") || document;
    var media = $(".product-media", scope);

    set.addEventListener("change", function (e) {
      var input = e.target;
      if (!input || input.type !== "radio") return;

      if (media) {
        var first = null;
        $$("[data-thumb]", media).forEach(function (b) {
          var mine = b.dataset.edition === input.value;
          b.hidden = !mine;
          b.removeAttribute("aria-current");
          if (mine && !first) first = b;
        });
        /* Clicking the thumb rather than reassigning the stage here: the
           thumb handler already clears srcset before setting src, and a
           second copy of that rule is a second place for it to be forgotten.
           It was forgotten once already, and the stage stopped responding. */
        if (first) first.click();
      }
      resolveVariant(scope);
    });
  });

  /* --- Add to cart --------------------------------------------------------
     Immediate, in place. No modal, no drawer that hijacks (§6). The label
     states the outcome and the masthead count ticks; both revert so the
     control never lies about what it will do next. */
  $$("[data-add]").forEach(function (btn) {
    var revert;
    btn.addEventListener("click", function () {
      var scope = btn.closest("section") || document;
      var qty = parseInt(($("[data-qty-out]", scope) || {}).textContent, 10) || 1;

      $$("[data-cart-count]").forEach(function (c) {
        c.textContent = (parseInt(c.textContent, 10) || 0) + qty;
      });

      btn.dataset.state = "added";
      btn.firstChild.nodeValue = "Added — €";
      btn.setAttribute("aria-live", "polite");

      clearTimeout(revert);
      revert = setTimeout(function () {
        delete btn.dataset.state;
        btn.firstChild.nodeValue = "Add to cart — €";
      }, 2400);
    });
  });

  /* --- Remove line ---------------------------------------------------------
     The prototype has no server, so its Remove is a <button> and this deletes
     the row to show the interaction. The THEME's Remove is a real link to
     /cart/change?quantity=0 -- and it kept the same class for styling, so
     until 2026-08-26 this fired there too, with no preventDefault: the row
     vanished locally, then the page reloaded from the server. Harmless on
     success; on a failed request the buyer watched a line disappear that was
     still in their cart, beside a subtotal that never moved.

     Simulating is now conditioned on the control being a <button>, which is
     what tells the two apart. A link is left alone and the platform handles
     it. Same lesson as [data-add] and [data-newsletter] -- the difference is
     that those two were disarmed by removing the attribute, and this one
     could not be, because the class is load-bearing for the CSS. */
  $$(".ledger__x").forEach(function (btn) {
    if (btn.tagName !== "BUTTON") return;
    btn.addEventListener("click", function () {
      var row = btn.closest("tr");
      if (row) row.remove();
    });
  });

  /* --- Newsletter ---------------------------------------------------------
     Inline, next to the field, in words (§6). Names the problem and the
     recovery; never a modal, never on load (§8). */
  $$("[data-newsletter]").forEach(function (form) {
    var input = $("input", form);
    var msg = $("[data-nl-msg]", form);
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var v = (input.value || "").trim();
      var ok = /^[^@\s]+@[^@\s.]+\.[^@\s]{2,}$/.test(v);
      msg.hidden = false;
      msg.className = ok ? "field__ok" : "field__err";
      msg.textContent = ok
        ? "Subscribed. Four or five emails a year, and an unsubscribe link in every one."
        : (v ? "That address is missing everything after the @. Check it and try again."
             : "An email address is needed here.");
      form.toggleAttribute("data-error", !ok);
      input.setAttribute("aria-invalid", ok ? "false" : "true");
      input.setAttribute("aria-describedby", msg.id || (msg.id = "nl-msg"));
      if (ok) input.value = "";
    });
  });

  /* --- Colour scheme ------------------------------------------------------
     Light is the default and is never inferred from the operating system. */
  var scheme = (function () { try { return localStorage.getItem("mr-scheme") || "light"; } catch (e) { return "light"; } })();
  /* The country/currency control. `closest("form")` is what makes one file
     serve both surfaces: on the shop the select sits inside Shopify's
     `{% form 'localization' %}` and changing it submits; in the prototype
     there is no form around it, so this no-ops rather than navigating
     nowhere. The <noscript> button is the route without this handler. */
  $$("[data-market]").forEach(function (sel) {
    sel.addEventListener("change", function () {
      var f = sel.closest("form");
      if (f) f.submit();
    });
  });

  function applyScheme(v) {
    if (v === "dark") document.documentElement.dataset.theme = "dark";
    else delete document.documentElement.dataset.theme;
    $$("[data-scheme]").forEach(function (b) {
      b.setAttribute("aria-pressed", String(b.dataset.scheme === v));
    });
    try { localStorage.setItem("mr-scheme", v); } catch (e) {}
  }
  $$("[data-scheme]").forEach(function (b) {
    b.addEventListener("click", function () { applyScheme(b.dataset.scheme); });
  });
  applyScheme(scheme);

  /* --- Cookies ------------------------------------------------------------
     Decline-by-default, minimal, dismissible, never blocking the page (§8).
     Both actions carry identical weight.

     Until 2026-08-26 this wrote localStorage and hid the bar, and did nothing
     else. `Shopify.customerPrivacy.setTrackingConsent` was never called
     anywhere in the theme, so DECLINE CHANGED NOTHING -- Shopify's own scripts
     loaded either way -- while the copy told an EU visitor "Nothing measures
     you unless you say so." A consent notice that makes a claim it does not
     enforce is a worse position than no notice, and it is the same class as
     the [data-newsletter] and [data-add] simulations the port removed.

     The choice is now carried to Shopify. The local record is kept only to
     decide whether to show the bar again; it is not the consent itself. */
  function tellShopify(choice) {
    var S = window.Shopify;
    /* Absent in the prototype, which has no Shopify runtime, so this whole
       branch is inert there and the two copies of this file stay identical. */
    if (!S || typeof S.loadFeatures !== "function") return;
    S.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function (err) {
      if (err || !S.customerPrivacy) return;
      var yes = choice === "accept";
      S.customerPrivacy.setTrackingConsent({
        analytics: yes, marketing: yes, preferences: yes, sale_of_data: false
      }, function () {});
    });
  }

  var bar = $("[data-cookies]");
  var stored;
  try { stored = localStorage.getItem("mr-cookies"); } catch (e) {}
  /* Re-declare a stored choice on every load. Choices made before this was
     wired were recorded and never carried anywhere; this is what makes them
     take effect rather than quietly staying decorative. */
  if (stored) tellShopify(stored);
  if (bar) {
    if (!stored) bar.hidden = false;
    $$("[data-cookie]", bar).forEach(function (b) {
      b.addEventListener("click", function () {
        try { localStorage.setItem("mr-cookies", b.dataset.cookie); } catch (e) {}
        tellShopify(b.dataset.cookie);
        bar.hidden = true;
      });
    });
  }

  /* --- Images -------------------------------------------------------------
     Space is reserved by the plate's aspect-ratio, so an image fades in
     without moving anything below it. */
  $$(".plate img").forEach(function (img) {
    if (img.complete) img.setAttribute("data-loaded", "");
    else img.addEventListener("load", function () { img.setAttribute("data-loaded", ""); });
  });
})();

/* Collection and colour filters, and the sort control.
   The select shipped with nothing bound to it. A control that does nothing is
   worse than no control: it reads as broken rather than absent. */
(function () {
  "use strict";
  /* This block sits outside the main closure above, so it cannot borrow its
     $ and $$ helpers -- doing so threw a ReferenceError and killed the whole
     filter behaviour silently. */
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) {
    return Array.prototype.slice.call((r || document).querySelectorAll(s));
  };

  var bar = $("[data-filters]");
  var state = { collection: null, colour: null };

  /* SCOPED TO THE CATALOGUE, not to the document.
     `$$(".item")` reached every cell on the page, so the moment a second
     section reused `.item` the filter hid it: picking any colour emptied the
     hand-picked sets shelf, sets included that were that very colour, because
     a set card carries no data-colour and "no colour" never matches one.
     The catalogue marks itself with [data-filter-scope]; anything outside it
     is somebody else's section and none of this control's business. Falling
     back to `document` keeps a page that has not marked a scope working
     exactly as before. */
  var scope = $("[data-filter-scope]") || document;

  function apply() {
    var shown = 0;
    $$(".item", scope).forEach(function (el) {
      var ok = (!state.collection || el.dataset.collection === state.collection) &&
               (!state.colour || el.dataset.colour === state.colour);
      el.hidden = !ok;
      if (ok) shown++;
    });
    /* A collection heading with every print hidden beneath it is a lie about
       what is there. */
    $$(".grid", scope).forEach(function (g) {
      var any = $$(".item", g).some(function (i) { return !i.hidden; });
      var head = g.previousElementSibling;
      g.hidden = !any;
      if (head && head.matches(".small, h2, .grid-head")) head.hidden = !any;
    });
    $$("[data-count]").forEach(function (c) { c.textContent = shown; });
    $$("[data-count-s]").forEach(function (c) { c.textContent = shown === 1 ? "" : "s"; });
    $$("[data-filter-clear]").forEach(function (c) {
      c.hidden = !state.collection && !state.colour;
    });
    var empty = $("[data-filter-empty]");
    if (empty) empty.hidden = shown !== 0;
  }

  function clear() {
    state.collection = state.colour = null;
    $$("[data-filter]").forEach(function (b) { b.setAttribute("aria-pressed", "false"); });
    apply();
  }

  if (bar) {
    $$("[data-filter]", bar).forEach(function (btn) {
      btn.addEventListener("click", function () {
        var k = btn.dataset.filter, v = btn.dataset.value;
        state[k] = state[k] === v ? null : v;      /* click again to unset */
        $$('[data-filter="' + k + '"]', bar).forEach(function (b) {
          b.setAttribute("aria-pressed", String(b.dataset.value === state[k]));
        });
        apply();
      });
    });
  }
  $$("[data-filter-clear]").forEach(function (c) {
    c.addEventListener("click", clear);
  });

  var sort = $("#sort");
  if (sort) sort.addEventListener("change", function () {
    var mode = sort.value;
    $$(".grid").forEach(function (g) {
      var items = $$(".item", g);
      items.sort(function (a, b) {
        if (mode.indexOf("Title") === 0)
          return (a.dataset.title || "").localeCompare(b.dataset.title || "");
        if (mode.indexOf("Price") === 0)
          return (+a.dataset.price || 0) - (+b.dataset.price || 0);
        return 0;                                  /* Newest is catalogue order */
      });
      items.forEach(function (i) { g.appendChild(i); });
    });
  });
})();
